import { IShipmentLocation } from '@cemex-core/cmx-api';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import {
  AsyncState,
  asyncFailed,
  asyncStart,
  asyncState,
  asyncSuccess,
  createAsyncState,
} from '@ordersnproducts/utils/create-async-state';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import ShipmentLocationActions from '../actions/shipment-location.actions';
import { IShipmentLocationWithFullAddress } from '@ordersnproducts/modules/shared/services/shipment-location-with-address';

interface ShipmentLocationEntityState extends EntityState<IShipmentLocationWithFullAddress> {
  activeEntityId: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ShipmentLocationState extends AsyncState<ShipmentLocationEntityState> {}

export const adapterShipmentLocation: EntityAdapter<IShipmentLocation> = createEntityAdapter<IShipmentLocation>({
  selectId: ({ shipmentLocationId }) => shipmentLocationId,
});

export const initialShipmentLocationState = createAsyncState({
  ...adapterShipmentLocation.getInitialState({
    activeEntityId: null,
  }),
});

export const shipmentLocationReducer = createReducer(
  initialShipmentLocationState,
  on(ShipmentLocationActions.fetch, asyncStart()),

  on(ShipmentLocationActions.fetchFailed, asyncFailed()),

  on(
    ShipmentLocationActions.fetchSuccess,
    asyncSuccess(({ payload }, state) => ({
      payload: {
        ...adapterShipmentLocation.setAll(payload, state.payload),
        isMultipleOrder: payload.length > 0,
        loadingMultipleOrder: false,
      },
    })),
  ),

  on(
    ShipmentLocationActions.setActive,
    asyncState(({ shipmentLocationId }, state) => ({
      payload: {
        ...state.payload,
        activeEntityId: shipmentLocationId,
      },
    })),
  ),

  on(ShipmentLocationActions.resetShipmentLocationState, (state) => ({
    ...initialShipmentLocationState,
  })),
);

export function reducer(state: ShipmentLocationState | undefined, action: Action) {
  return shipmentLocationReducer(state, action);
}
